/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createBrowserHistory } from 'history';

import rootReducer from './reducers';

export const historyH = createBrowserHistory();

const initialState = getDemoInitialState();

export const configureStore = () => {
  const store = createStore(
    rootReducer,
    initialState,
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? compose(
        applyMiddleware(thunkMiddleware),
        window.__REDUX_DEVTOOLS_EXTENSION__(),
      )
      : applyMiddleware(thunkMiddleware),
  );

  historyH.listen(location => {
    // save location into global state
    store.dispatch({ type: 'ROUTE.SAVE_LOCATION', payload: location });
  });

  window.store = store;
  window.s = (param) => {
    const state = store.getState();
    console.log(JSON.stringify((!param) ? state : state[param], null, 2));
  };
  return store;
};

function getDemoInitialState() {
  return ({
    "datasets": {
      "marine-biology": {
        "title": "Marine Biology Domain",
        "datasets": {
          "marine-biology-1": {
            "id": "marine-biology-1",
            "explore": "Explore 7002 fishes",
            "info": "FishBase (700)",
            "images": "Yes",
            "geo": "No"
          },
          "marine-biology-2": {
            "id": "marine-biology-2",
            "explore": "Explore 7031 fishes",
            "info": "FishBase (712300)",
            "images": "No",
            "geo": "No"
          }
        }
      },
      "astronomy-domain": {
        "title": "Astronomy",
        "datasets": {
          "astronomy-domain-1": {
            "id": "astronomy-domain-1",
            "explore": "with map",
            "info": "Stellar Objects",
            "images": "No",
            "geo": "Yes"
          }
        }
      }
    },
    "tabs": {
      "2": {
        "tabId": 2,
        "dataset": {
          "id": "marine-biology-1",
          "explore": "Explore 7002 fishes",
          "info": "FishBase (700)",
          "images": "Yes",
          "geo": "No"
        },
        "routePath": "/dataset/2",
        "sessionId": "session1",
        "title": "FishBase (700)",
        "selections": {
          "showJustTheMap": false
        }
      },
      "4": {
        "tabId": 4,
        "dataset": {
          "id": "astronomy-domain-1",
          "explore": "with map",
          "info": "Stellar Objects",
          "images": "No",
          "geo": "Yes"
        },
        "routePath": "/dataset/4",
        "sessionId": "session3",
        "title": "Stellar Objects",
        "selections": {
          "showJustTheMap": false
        }
      }
    },
    "facets": {
      "allTypes": {
        "marine-biology-1": {
          "some-facet-type-id-1": {
            "id": "some-facet-type-id-1",
            "datasetId": "marine-biology-1",
            "title": "with images",
            "items": "150",
            "setValued": true,
            "hasImages": true
          },
          "some-facet-type-id-2": {
            "id": "some-facet-type-id-2",
            "datasetId": "marine-biology-1",
            "title": "simple",
            "items": "1500",
            "setValued": false,
            "hasImages": false
          },
          "some-facet-type-id-3": {
            "id": "some-facet-type-id-3",
            "datasetId": "marine-biology-1",
            "title": "empty (right mouse click for custom menu)",
            "items": "12350",
            "setValued": true,
            "hasImages": false
          }
        }
      },
      "allSubTypes": {
        "marine-biology-1": {
          "some-facet-type-id-1": {
            "FacetSubType1": {
              "id": "FacetSubType1",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            },
            "FacetSubType2": {
              "id": "FacetSubType2",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype2",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            },
            "FacetSubType3": {
              "id": "FacetSubType3",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype3",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            },
            "FacetSubType4": {
              "id": "FacetSubType4",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype4",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            },
            "FacetSubType5": {
              "id": "FacetSubType5",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype5",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            },
            "FacetSubType6": {
              "id": "FacetSubType6",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype6",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            },
            "FacetSubType7": {
              "id": "FacetSubType7",
              "typeId": "some-facet-type-id-1",
              "title": "this is a facet subtype7",
              "items": "50",
              "img": "https://source.unsplash.com/random"
            }
          },
          "some-facet-type-id-2": {
            "FacetSubType1": {
              "id": "FacetSubType1",
              "typeId": "some-facet-type-id-2",
              "title": "this is a facet subtype",
              "items": "50",
              "img": ""
            },
            "FacetSubType2": {
              "id": "FacetSubType2",
              "typeId": "some-facet-type-id-2",
              "title": "this is a facet subtype2",
              "items": "50",
              "img": ""
            },
            "FacetSubType3": {
              "id": "FacetSubType3",
              "typeId": "some-facet-type-id-2",
              "title": "this is a facet subtype3",
              "items": "50",
              "img": ""
            }
          },
          "astronomy-1": {}
        }
      }
    },
    "cards": {
      "buckets": {
        "1": {
          "img-id-1": {
            "title": "test1 (hover)",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-2": {
            "title": "test2",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-3": {
            "title": "test3",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-4": {
            "title": "test4",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-21": {
            "title": "test5",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-22": {
            "title": "test6",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-23": {
            "title": "test7",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-24": {
            "title": "test8",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-11": {
            "title": "test9",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-12": {
            "title": "test10",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-13": {
            "title": "test11",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-14": {
            "title": "test12",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-15": {
            "title": "test13",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-16": {
            "title": "test14",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-17": {
            "title": "test15",
            "img": "https://source.unsplash.com/random/190x160"
          }
        },
        "2": {
          "img-id-221": {
            "title": "test13",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-2322": {
            "title": "test14",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-2323": {
            "title": "test15",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-2324": {
            "title": "test16",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-2321": {
            "title": "test17",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-222": {
            "title": "test18",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-223": {
            "title": "test19",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-224": {
            "title": "test20",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-211": {
            "title": "test21",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-212": {
            "title": "test22",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-213": {
            "title": "test23",
            "img": "https://source.unsplash.com/random/190x160"
          },
          "img-id-214": {
            "title": "test24",
            "img": "https://source.unsplash.com/random/190x160"
          }
        }
      }
    },
    "general": {
      "location": {
        "pathname": "/dataset/2",
        "search": "",
        "hash": "",
        "key": "51totk"
      }
    }
  });
}